var cov_qhkbg08xb = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formContext.tsx",
      hash = "d925a41d39b1d7dafc3dba03da0513e6d7407b65",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formContext.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 76
        }
      },
      "1": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "2": {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 22,
          column: 40
        }
      },
      "3": {
        start: {
          line: 24,
          column: 29
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "4": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 18
        }
      },
      "5": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 54
        }
      },
      "6": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 35,
          column: 34
        }
      },
      "7": {
        start: {
          line: 36,
          column: 46
        },
        end: {
          line: 36,
          column: 48
        }
      },
      "8": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      "9": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 88
        }
      },
      "10": {
        start: {
          line: 39,
          column: 13
        },
        end: {
          line: 41,
          column: 7
        }
      },
      "11": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 24
        }
      },
      "12": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "13": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 45
        }
      },
      "14": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 21
        }
      },
      "15": {
        start: {
          line: 65,
          column: 10
        },
        end: {
          line: 65,
          column: 20
        }
      },
      "16": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "17": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 83,
          column: 7
        }
      },
      "18": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 87,
          column: 21
        }
      },
      "19": {
        start: {
          line: 94,
          column: 28
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "20": {
        start: {
          line: 100,
          column: 24
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "21": {
        start: {
          line: 101,
          column: 30
        },
        end: {
          line: 101,
          column: 32
        }
      },
      "22": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 28
        }
      },
      "23": {
        start: {
          line: 102,
          column: 18
        },
        end: {
          line: 102,
          column: 28
        }
      },
      "24": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 29
        }
      },
      "25": {
        start: {
          line: 103,
          column: 17
        },
        end: {
          line: 103,
          column: 29
        }
      },
      "26": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 108,
          column: 8
        }
      },
      "27": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 28
        }
      },
      "28": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 43
        }
      },
      "29": {
        start: {
          line: 107,
          column: 31
        },
        end: {
          line: 107,
          column: 43
        }
      },
      "30": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 16
        }
      },
      "31": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "32": {
        start: {
          line: 115,
          column: 28
        },
        end: {
          line: 115,
          column: 46
        }
      },
      "33": {
        start: {
          line: 116,
          column: 10
        },
        end: {
          line: 116,
          column: 115
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 29
          },
          end: {
            line: 24,
            column: 30
          }
        },
        loc: {
          start: {
            line: 26,
            column: 56
          },
          end: {
            line: 88,
            column: 1
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 59
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        loc: {
          start: {
            line: 34,
            column: 78
          },
          end: {
            line: 48,
            column: 5
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 5
          }
        },
        loc: {
          start: {
            line: 54,
            column: 13
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 95,
            column: 3
          },
          end: {
            line: 95,
            column: 4
          }
        },
        loc: {
          start: {
            line: 99,
            column: 7
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 99
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 100,
            column: 24
          },
          end: {
            line: 100,
            column: 25
          }
        },
        loc: {
          start: {
            line: 100,
            column: 48
          },
          end: {
            line: 110,
            column: 5
          }
        },
        line: 100
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 105,
            column: 19
          },
          end: {
            line: 105,
            column: 20
          }
        },
        loc: {
          start: {
            line: 105,
            column: 24
          },
          end: {
            line: 108,
            column: 7
          }
        },
        line: 105
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 114,
            column: 9
          },
          end: {
            line: 114,
            column: 10
          }
        },
        loc: {
          start: {
            line: 114,
            column: 18
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 25
          }
        }, {
          start: {
            line: 37,
            column: 29
          },
          end: {
            line: 37,
            column: 33
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 38,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 38,
            column: 54
          }
        }, {
          start: {
            line: 38,
            column: 58
          },
          end: {
            line: 38,
            column: 60
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 29
          }
        }, {
          start: {
            line: 69,
            column: 33
          },
          end: {
            line: 69,
            column: 40
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 102,
            column: 6
          },
          end: {
            line: 102,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 6
          },
          end: {
            line: 102,
            column: 28
          }
        }, {
          start: {
            line: 102,
            column: 6
          },
          end: {
            line: 102,
            column: 28
          }
        }],
        line: 102
      },
      "7": {
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 29
          }
        }, {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 29
          }
        }],
        line: 103
      },
      "8": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 43
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 43
          }
        }],
        line: 107
      },
      "9": {
        loc: {
          start: {
            line: 116,
            column: 66
          },
          end: {
            line: 116,
            column: 111
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 66
          },
          end: {
            line: 116,
            column: 84
          }
        }, {
          start: {
            line: 116,
            column: 88
          },
          end: {
            line: 116,
            column: 111
          }
        }],
        line: 116
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formContext.tsx",
    _this2 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import createReactContext from '../context';
import { deepGet } from '../utils/objects';
import { isObject, isArray } from '../utils/is';
import { curry3 } from '../utils/func'; // 去掉独有的属性

var context = (cov_qhkbg08xb.s[0]++, createReactContext({})); // eslint-disable-next-line

export var Provider = (cov_qhkbg08xb.s[1]++, context.Provider); // eslint-disable-next-line

export var Consumer = (cov_qhkbg08xb.s[2]++, context.Consumer);
cov_qhkbg08xb.s[3]++;
export var formProvider = function formProvider(Origin) {
  cov_qhkbg08xb.f[0]++;

  var FormProvider =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FormProvider, _PureComponent);

    var _super = _createSuper2(FormProvider);

    function FormProvider(props) {
      var _this;

      _classCallCheck(this, FormProvider);

      cov_qhkbg08xb.f[1]++;
      cov_qhkbg08xb.s[4]++;
      _this = _super.call(this, props);
      cov_qhkbg08xb.s[5]++;
      _this.combineRules = _this.combineRules.bind(_assertThisInitialized(_this)); // this.groupValidate = this.groupValidate.bind(this)

      return _this;
    }

    _createClass(FormProvider, [{
      key: "combineRules",
      value: function combineRules(name, propRules) {
        cov_qhkbg08xb.f[2]++;

        var _ref = (cov_qhkbg08xb.s[6]++, this.props),
            rules = _ref.rules;

        var newRules = (cov_qhkbg08xb.s[7]++, []);
        cov_qhkbg08xb.s[8]++;

        if ((cov_qhkbg08xb.b[1][0]++, isObject(rules)) && (cov_qhkbg08xb.b[1][1]++, name)) {
          cov_qhkbg08xb.b[0][0]++;
          cov_qhkbg08xb.s[9]++;
          newRules = (cov_qhkbg08xb.b[2][0]++, deepGet(rules, name)) || (cov_qhkbg08xb.b[2][1]++, []);
        } else {
          cov_qhkbg08xb.b[0][1]++;
          cov_qhkbg08xb.s[10]++;

          if (isArray(rules)) {
            cov_qhkbg08xb.b[3][0]++;
            cov_qhkbg08xb.s[11]++;
            newRules = rules;
          } else {
            cov_qhkbg08xb.b[3][1]++;
          }
        }

        cov_qhkbg08xb.s[12]++;

        if (isArray(propRules)) {
          cov_qhkbg08xb.b[4][0]++;
          cov_qhkbg08xb.s[13]++;
          newRules = newRules.concat(propRules);
        } else {
          cov_qhkbg08xb.b[4][1]++;
        }

        cov_qhkbg08xb.s[14]++;
        return newRules;
      } // groupValidate(name) {
      // not implement...
      // }

    }, {
      key: "render",
      value: function render() {
        cov_qhkbg08xb.f[3]++;

        var _ref2 = (cov_qhkbg08xb.s[15]++, this.props),
            datum = _ref2.datum,
            labelAlign = _ref2.labelAlign,
            labelVerticalAlign = _ref2.labelVerticalAlign,
            labelWidth = _ref2.labelWidth,
            disabled = _ref2.disabled,
            pending = _ref2.pending,
            mode = _ref2.mode,
            size = _ref2.size,
            keepErrorHeight = _ref2.keepErrorHeight;

        var value = (cov_qhkbg08xb.s[16]++, {
          formDatum: datum,
          formMode: mode,
          disabled: !!((cov_qhkbg08xb.b[5][0]++, disabled) || (cov_qhkbg08xb.b[5][1]++, pending)),
          labelAlign: labelAlign,
          labelVerticalAlign: labelVerticalAlign,
          labelWidth: labelWidth,
          size: size,
          combineRules: this.combineRules,
          // groupValidate: this.groupValidate,
          keepErrorHeight: keepErrorHeight
        });
        cov_qhkbg08xb.s[17]++;
        return (
          /*#__PURE__*/
          React.createElement(Provider, {
            value: value,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 80,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, this.props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 81,
              columnNumber: 11
            }
          })))
        );
      }
    }]);

    return FormProvider;
  }(PureComponent);

  cov_qhkbg08xb.s[18]++;
  return FormProvider;
};
export var formConsumer = (cov_qhkbg08xb.s[19]++, curry3(function (keys, Origin, props) {
  cov_qhkbg08xb.f[4]++;
  cov_qhkbg08xb.s[20]++;

  var filterProps = function filterProps(value) {
    cov_qhkbg08xb.f[5]++;
    var cps = (cov_qhkbg08xb.s[21]++, {});
    cov_qhkbg08xb.s[22]++;

    if (!value) {
      cov_qhkbg08xb.b[6][0]++;
      cov_qhkbg08xb.s[23]++;
      return cps;
    } else {
      cov_qhkbg08xb.b[6][1]++;
    }

    cov_qhkbg08xb.s[24]++;

    if (!keys) {
      cov_qhkbg08xb.b[7][0]++;
      cov_qhkbg08xb.s[25]++;
      return value;
    } else {
      cov_qhkbg08xb.b[7][1]++;
    }

    cov_qhkbg08xb.s[26]++;
    keys.forEach(function (k) {
      cov_qhkbg08xb.f[6]++;
      var val = (cov_qhkbg08xb.s[27]++, value[k]);
      cov_qhkbg08xb.s[28]++;

      if (val !== undefined) {
        cov_qhkbg08xb.b[8][0]++;
        cov_qhkbg08xb.s[29]++;
        cps[k] = val;
      } else {
        cov_qhkbg08xb.b[8][1]++;
      }
    });
    cov_qhkbg08xb.s[30]++;
    return cps;
  };

  cov_qhkbg08xb.s[31]++;
  return (
    /*#__PURE__*/
    React.createElement(Consumer, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 7
      }
    }, function (value) {
      cov_qhkbg08xb.f[7]++;
      var formProps = (cov_qhkbg08xb.s[32]++, filterProps(value));
      cov_qhkbg08xb.s[33]++;
      return (
        /*#__PURE__*/
        React.createElement(Origin, Object.assign({}, formProps, props, {
          disabled: (cov_qhkbg08xb.b[9][0]++, formProps.disabled) || (cov_qhkbg08xb.b[9][1]++, props.disabled),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116,
            columnNumber: 18
          }
        }))
      );
    })
  );
}));